import { defineStore } from "pinia";
import { nasna } from "../http-common.js"
import { acceptTVCode } from "@/Gql/auth.js";
import apolloClient from "../plugins/apollo";
import { useToast } from "vue-toastification";


export const useAuthStore = defineStore("auth", {
    state: () => {
        return {
            isLoggedin: Boolean, // check user status 
            user: JSON.parse(localStorage.getItem("user")), // user data to be stored 
            token: localStorage.getItem("token") || "",
            phone: "",
            isActive: localStorage.getItem("isActive") === "true",
            toast: useToast()

        }
    },// end of state
    getters: {
        getUser: (state) => state.user,
        isAuthenticated: (state) => state.user != undefined,
        getPhone: (state) => state.phone,
        getISActive: (state) => state.isActive,

    }, //end of getters 
    actions: {
        /**
         * https://api.nasna.tv/api/auth/subscriptions/status/:msisdn
         * subscribe 
         */
        async subscribeAction() {
            window.location.href = "https://api.nasna.tv/api/auth/sd/subscriptions/redirect";

        },
     
        /**
         * login user for authentication purpose 
         */
        async verifyTvPinCode(userID, code) {
            return new Promise((resolve, reject) => {
              apolloClient
                .mutate({
                  mutation: acceptTVCode,
                  variables: {
                    userId: userID, // Corrected variable name
                    code
                  },
                })
                .then((response) => {
                  console.log(response.data.acceptTVCode);
                  resolve(response);
                })
                .catch((error) => {
                  this.error = error;
                  reject(error);
                });
            });
          },
        /**
         * checking user subscribtion status
         */
        async checkSubescriptionStatus(phone, packageName="daily", user_id = null) {


            return new Promise((resolve) => {
                nasna.post(`/auth/sd/subscriptions/status/${phone}/${packageName.toLowerCase()}`, { user_id : user_id }).then(async response => (
                    await this.setData(response)
                    , resolve(response)));

            })

        },
        async setData(response) {

            if (response.data.status) {
                this.user = response.data.user || null;
                this.token = response.data.token || "";
                this.isActive = Boolean(response.data.token);

                window.localStorage.setItem('user', JSON.stringify(response.data.user));
                window.localStorage.setItem('token', response.data.token);
                window.localStorage.setItem('isActive', response.data.token ? true : false);
                window.localStorage.setItem('phone', response.data.package);

            } else {
                this.wipeUserData(response)
            }

        },

        async unsubscribe() {
            let user = JSON.parse(localStorage.getItem('user'));
            const packageName = window.localStorage.getItem('package');

            if (user != null) {


                return new Promise((resolve) => {
                    nasna.post(`/auth/sd/subscriptions/cancel/${user.phone}/${packageName}`).then((response) => 
                     {
                           if(response.data?.success || response.data.status){
                             this.toast.success("تم إلغاء الاشتراك بنجاح");
                        }
                        this.wipeUserData(response)

                        , resolve(response)
                     });

                })

            }
        },

        wipeUserData(response) {
            if (response.data.status == true || response.data.status == false || response.data.isSent == true || response.data.responseMessage == "Your Are UnSubscribe Successfully" || response.data.responseMessage == "MSISDN already UnSubscribed ") {
                this.user = null;
                this.token = "";
                this.isActive = false;
                this.phone = "";
                window.localStorage.removeItem("user"),
                    window.localStorage.removeItem("token"),
                    window.localStorage.removeItem("isActive"),
                    window.localStorage.removeItem("phone"),
                    window.localStorage.removeItem("package")

            }
        },

        async login(phone) {
            await nasna.post(`login/subscribe_ok?msisdn=/${phone}`).then(async response => (console.log(response)))
        },


        /**
         * logout the current authenticated user
         */
        logOut() {
            this.user = null;
            this.token = "";
            this.isActive = false;
            this.phone = "";
            window.localStorage.removeItem("user");
            window.localStorage.removeItem("token");
            window.localStorage.removeItem("key");
            window.localStorage.removeItem("isActive");
            window.localStorage.removeItem("phone");
            window.localStorage.removeItem("package");
        }
    }
})